const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		defaultFieldSelector: '[data-field-code="default"]',
		dateFieldSelector: '[data-field-code="date"]',
		additionalFieldsFormSelector: '.templates_propertiesForms_segmentationValueComponentDataForm',
		additionalFieldsSelector: '.templates_propertiesForms_segmentationValueComponentDataForm .field',
		simpleSubForm: true
	},

	model: {
		updateFieldIfPossible: false,
		actualFieldName: '',
		realFieldName: ''
	},

	methods: {
		childChanged: function(valueDefinition, init){
			if(!valueDefinition.renderedFieldCode || this.model.realFieldName === valueDefinition.renderedFieldCode){
				if(!valueDefinition.value || valueDefinition.value === null){
					valueDefinition.value = '';
				} else if(this.model.realFieldName === 'createdAt'){
					valueDefinition.value = utils.moment(valueDefinition.value).format('YYYY-MM-DD');
				}

				valueDefinition.fieldCode = 'segmentationValue';
				this.triggerClosest('onChildChanged', valueDefinition);
			}
		},

		updateFieldName: function(fieldName, force, fieldValue){
			force = force || this.model.actualFieldName !== fieldName;

			if(force){
				var $element = this.$;
				this.model.actualFieldName 	= String(fieldName);
				this.model.realFieldName 	= String(fieldName).replace(/^a_/, '');

				// additional data field
				if(this.model.actualFieldName !== this.model.realFieldName){
					this.childChanged({ value: fieldValue });
					var formComponent = getComponent($element.find(this.config.additionalFieldsFormSelector));

					var dirtyAttributes = {};
					if(fieldValue === undefined) 	dirtyAttributes[this.model.realFieldName] = null;
					else 							dirtyAttributes[this.model.realFieldName] = fieldValue;
					formComponent.model.dirtyFields = {
						data: {
							attributes: dirtyAttributes
						}
					};
					formComponent.refresh(false);

					$element.find(this.config.defaultFieldSelector).closest('.field').addClass('hidden');
					$element.find(this.config.dateFieldSelector).closest('.field').addClass('hidden');
					$element.find(this.config.additionalFieldsFormSelector).removeClass('hidden');
					$element.find(this.config.additionalFieldsSelector).addClass('hidden');
					$element.find(this.config.additionalFieldsSelector).find('[data-field-code="' + this.model.realFieldName + '"]').closest('.field').removeClass('hidden');
				}
				// date data field
				else if(this.model.realFieldName === 'createdAt') {
					var now = null;
					var nowValue = null;
					if(fieldValue){
						now = new Date(fieldValue);
						nowValue = now.toISOString();
					}
					this.childChanged({ value: nowValue });
					var dateComponent;
					if((dateComponent = getComponent($element.find(this.config.dateFieldSelector).closest('.base_form_fields_air-datetime-picker')))){
						dateComponent.setDate(now);
					}

					$element.find(this.config.defaultFieldSelector).closest('.field').addClass('hidden');
					$element.find(this.config.dateFieldSelector).closest('.field').removeClass('hidden');
					$element.find(this.config.additionalFieldsFormSelector).addClass('hidden');
					$element.find(this.config.additionalFieldsSelector).addClass('hidden');
				}
				// default data field
				else {
					this.childChanged({ value: fieldValue || '' });
					$element.find(this.config.defaultFieldSelector).val(fieldValue || '').closest('.field').removeClass('hidden');
					$element.find(this.config.dateFieldSelector).closest('.field').addClass('hidden');
					$element.find(this.config.additionalFieldsFormSelector).addClass('hidden');
					$element.find(this.config.additionalFieldsSelector).addClass('hidden');
				}

				this.triggerClosest('fieldNameUpdated');
			}
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(self.model.updateFieldIfPossible){
				self.updateFieldName(self.model.actualFieldName, true, self.model.value);
			}
		},
		onChildChanged: function($element, options){
			this.childChanged(options);
		},

		segmentationValueComponentDataFormReady: function($elem, options){
			if(this.config.isReady) this.updateFieldName(this.model.actualFieldName, true, this.model.value);
			else 					this.model.updateFieldIfPossible = true;
		},

		segmentationFieldChanged: function($element, options){
			this.model.value = options.fieldValue;
			if(this.model.updateFieldIfPossible) 	this.updateFieldName(options.fieldName, true, this.model.value);
			else 									this.updateFieldName(options.fieldName);
			this.model.updateFieldIfPossible = false;
		},

		onRefreshDone: function($element, options){
			this.updateFieldName(this.model.actualFieldName, true, this.model.value);
		}
	}
}